var _g, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAudioEnabled = function SvgAudioEnabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M49.9.5h0A49.5,49.5,0,0,1,99.4,50h0A49.5,49.5,0,0,1,49.9,99.5h0A49.5,49.5,0,0,1,.4,50h0A49.5,49.5,0,0,1,49.9.5Z",
    fill: "#159a2e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-microphone",
    "data-name": "Icon awesome-microphone",
    d: "M51.24,58.67a9.58,9.58,0,0,0,9.57-9.57V33.17a9.57,9.57,0,0,0-19.14,0h0V49.11A9.57,9.57,0,0,0,51.24,58.67ZM67.18,42.73h-1.6A1.59,1.59,0,0,0,64,44.32V49.1A12.76,12.76,0,0,1,51.21,61.85c-.42,0-.83,0-1.25-.06A13.13,13.13,0,0,1,38.49,48.53V44.32a1.6,1.6,0,0,0-1.6-1.58H35.3a1.6,1.6,0,0,0-1.6,1.58v4a18.08,18.08,0,0,0,15.15,18.1v3.4H43.27a1.6,1.6,0,0,0-1.59,1.6V73a1.59,1.59,0,0,0,1.59,1.59H59.21A1.6,1.6,0,0,0,60.81,73h0V71.42a1.6,1.6,0,0,0-1.6-1.6H53.63V66.46A17.56,17.56,0,0,0,68.77,49.1V44.32a1.6,1.6,0,0,0-1.59-1.58Z",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAudioEnabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audio-enabled.cbc0dfba.svg";
export { ForwardRef as ReactComponent };